export default __webpack_public_path__ + "static/step-6-a155617656e0cb44533c8fc7947168c1.png";